import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../builder';
import { CTARounded } from './CTARounded';
import { COLOR_KEYS_LIST } from '../../../constants';
import { SectionName, withTracking } from '../../../observability';

export default createBuilderModule(
  withChildren(
    withTracking(CTARounded, {
      as: 'section',
      sectionName: SectionName.CTARounded,
    }),
  ),
  {
    name: 'CTARounded',
    image: 'https://cdn.zappy.app/47d02a6148b9ed6140d1aaa5a50326a3.png',
    inputs: [
      { name: 'backgroundColor', type: 'string', enum: COLOR_KEYS_LIST },
      {
        name: 'secondaryBackgroundColor',
        type: 'string',
        enum: ['', ...COLOR_KEYS_LIST],
        helperText:
          'The background color behind the rounded container. If not set, the background color will be inherited from the page.',
      },
      { name: 'heading', required: true, type: 'string' },
      { name: 'ctaText', type: 'string' },
      { name: 'ctaHref', type: 'string' },
    ],
  },
);
